import { Link, NavLink, useNavigate } from "react-router-dom";
import { Navbar, Nav, Container, Button, Offcanvas } from "react-bootstrap";
import { useEffect, useState } from "react";

import logo from "../assets/images/logo/logoaward.png";
import AutoImagePopup from "../PopupImage";
import VideoPopup from "../PopupVideo";

export default function Header() {
  const [show, setShow] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // 🔹 Check login status
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("election_user"));
    setUser(storedUser);
  }, []);

  // 🔹 Logout
  const handleLogout = () => {
    localStorage.removeItem("election_user");
    setUser(null);
    navigate("/login");
  };

  const dashboardRoute =
    user?.role === "voter" ? "/voter/dashboard" : "/candidate/dashboard";

  return (
    <>
      <Navbar
        variant="dark"
        sticky="top"
        className="shadow"
        style={{ background: "#000000" }}
      >
        <Container>
          {/* Toggle LEFT */}
          <Button
            variant="outline-light"
            className="d-lg-none me-2"
            onClick={() => setShow(true)}
          >
            ☰
          </Button>

          {/* Brand */}
          <Navbar.Brand as={Link} to="/" className="fw-bold">
            <img
              src={logo}
              alt="Awards Logo"
              width="120"
              height="60"
              className="d-inline-block align-top"
              style={{ borderRadius: "10px" }}
            />
          </Navbar.Brand>

          {/* Desktop Menu */}
          <Nav className="ms-auto d-none d-lg-flex align-items-center">
            <Nav.Link as={NavLink} to="/">
              Home
            </Nav.Link>
            {/* <Nav.Link as={NavLink} to="/vote">
              Vote
            </Nav.Link>
            <Nav.Link as={NavLink} to="/candidates">
              Candidates
            </Nav.Link> */}
            <Nav.Link as={NavLink} to="/contact-us">
              ContactUs
            </Nav.Link>
            <Nav.Link as={NavLink} to="/public-result">
              Results
            </Nav.Link>

            {!user ? (
              <>
                {/* <Button
                  variant="warning"
                  size="sm"
                  className="ms-2"
                  onClick={() => navigate("/candidate/register")}
                >
                  Candidate Register
                </Button> */}

                {/* <Button
                  variant="warning"
                  size="sm"
                  className="ms-2"
                  onClick={() => navigate("/voter/register")}
                >
                  Voter Register
                </Button> */}

                <Button
                  variant="outline-warning"
                  size="sm"
                  className="ms-2"
                  onClick={() => navigate("/login")}
                >
                  Login
                </Button>
              </>
            ) : (
              <>
                <Button
                  // variant="success"
                  size="sm"
                  className="ms-2"
                  onClick={() => navigate(dashboardRoute)}
                  // style={{ background: "white", color: "black" }}
                >
                  Dashboard
                </Button>

                <Button
                  variant="outline-danger"
                  size="sm"
                  className="ms-2"
                  onClick={handleLogout}
                >
                  Logout
                </Button>
              </>
            )}
          </Nav>
        </Container>
      </Navbar>

      {/* MOBILE MENU */}
      <Offcanvas
        show={show}
        onHide={() => setShow(false)}
        placement="start"
        className="bg-dark text-light"
      >
        <Offcanvas.Header closeButton closeVariant="white">
          <Offcanvas.Title>🏆 Awards Election</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <Nav className="flex-column fs-5 gap-3">
            <Nav.Link as={NavLink} to="/" onClick={() => setShow(false)}>
              Home
            </Nav.Link>
            {/* <Nav.Link as={NavLink} to="/vote" onClick={() => setShow(false)}>
              Vote
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/candidates"
              onClick={() => setShow(false)}
            >
              Candidates
            </Nav.Link> */}
            <Nav.Link as={NavLink} to="/public-result">
              Results
            </Nav.Link>
            <hr className="border-secondary" />

            {!user ? (
              <>
                <Button
                  variant="outline-warning"
                  onClick={() => {
                    setShow(false);
                    navigate("/login");
                  }}
                >
                  Login
                </Button>

                {/* <Button
                  variant="warning"
                  onClick={() => {
                    setShow(false);
                    navigate("/candidate/register");
                  }}
                >
                  Candidate Register
                </Button> */}

                <Button
                  variant="warning"
                  onClick={() => {
                    setShow(false);
                    navigate("/voter/register");
                  }}
                >
                  Voter Register
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="success"
                  onClick={() => {
                    setShow(false);
                    navigate(dashboardRoute);
                  }}
                >
                  Dashboard
                </Button>

                <Button
                  variant="outline-danger"
                  onClick={() => {
                    setShow(false);
                    handleLogout();
                  }}
                >
                  Logout
                </Button>
              </>
            )}
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>

      {/* AUTO IMAGE POPUP */}
      {/* <AutoImagePopup src="/popup/banner.jpg" /> */}
      {/* <VideoPopup /> */}
    </>
  );
}
